import React from 'react';
import { Fill, Left } from 'react-spaces';
import { Navigate, Outlet, useLocation, useParams } from 'react-router-dom';
import { Segment } from 'semantic-ui-react';
import { useResponsive } from 'ahooks';

import { useAppDispatch, useAppSelector } from 'src/store';
import {
  ClassSider,
  CourseNotificationMessage,
  SiderTrigger,
} from 'src/components/coreUI';
import { classByIdSelector } from 'src/store/model/classes';
import { isUnavailableCoursePath } from 'src/utils/helper';
import { hideProgrammeBios } from 'src/utils/courseCapabilities';
import { PATH } from 'src/constants/app';
import drawer from 'src/store/ui/drawer';
import { ContentGrid } from 'src/components/custom';

const Class: React.FC = ({ children }) => {
  const layoutSplit = useAppSelector((state) => state.ui.app.layoutSplit);
  const screen = useResponsive();
  const dispatch = useAppDispatch();
  const { class_id } = useParams();

  const { pathname } = useLocation();
  const course = useAppSelector((state) => classByIdSelector(state, class_id!));
  const email = useAppSelector((state) => state.ui.app.me?.email);
  if (
    isUnavailableCoursePath(course?.type, pathname) ||
    (pathname.split('/')[3] === 'programme-bios' &&
      hideProgrammeBios(course, email))
  )
    return <Navigate to={`/${PATH.CLASS}/${class_id}`} replace />;

  return (
    <Fill as="main">
      {/* tablet and mobile will be hide */}
      <Left size={!screen.lg ? '0%' : layoutSplit}>
        <aside className="layout_class layout_class_left">
          <ClassSider />
        </aside>
      </Left>

      {/* Right */}
      <Fill scrollable className="shadow-top">
        <div className="layout_class layout_class_right">
          <Segment className="full_height px-24">
            {!screen.lg && (
              <SiderTrigger
                onClick={() => dispatch(drawer.open({ name: 'class_sider' }))}
              />
            )}
            <div>
              <ContentGrid className="py-0">
                <CourseNotificationMessage
                  class_id={class_id}
                  style={{ marginBottom: -24 }}
                />
              </ContentGrid>
              {children || <Outlet />}
            </div>
          </Segment>
        </div>
      </Fill>
    </Fill>
  );
};

export default React.memo(Class);
